import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import IdleSessionTimeout from './components/IdleSessionTimeout'
import { isTokenValid } from './util/auth'
import DefaultLayout from './layout/DefaultLayout'

const ProtectedRoute = () => {
  const isLoggedIn = isTokenValid()

  return isLoggedIn ? (
    <IdleSessionTimeout>
      <DefaultLayout>
        <Outlet />
      </DefaultLayout>
    </IdleSessionTimeout>
  ) : (
    <Navigate to="/" />
  )
}

export default ProtectedRoute
